<template>
	<div>
		<div id="modalX-container" class="four" v-if="showModal" @click="closeModalViaBackground" >
			<div class="modalX-background" ref="modalBackground">
				<div class="modalX">

						<div v-if="loading" class="uk-padding 19-6" style="width: 200px; height: 200px">
								<div class="uk-position-center">
									<loading-indicator></loading-indicator>
								</div>
						</div>
						
						<!-- videoplayer -->
						<div v-else-if="entry && entry.media">
							<video-player 
								:id="entry.media.id"
								:analytics="false"	
								title="entry.title"
								:ads="{ 
									'website': false, 
									'app': false
								}"								
								:ads-vdur="10"
								:viewport-observer="false"
								:plays-inline="true"
								:auto-size="true" 
								force-max-height="70vh"
								:options="{
									autoplay: true,
									loop: true,
									fluid: true,
									fill: true,
									width: entry.media.width,
									height: entry.media.height,
									poster: entry.media.poster,
									sources: [
										{ src: entry.media.url, type: 'video/mp4' },
										{ src: entry.media.original, type: 'video/mp4' }
									]
								}">
							</video-player>			
	
							<h4 style="margin-bottom: 0; margin-top: 20px">{{ entry.title }}</h4>

							<!-- footer -->
							<div class="uk-grid-small uk-flex-middle uk-text-center meta" uk-grid>
		
								<div class="uk-width-1-1 uk-text-center">	
									<div class="uk-flex uk-flex-middle uk-flex-center">
																	
										<article-share 
											:url="entry.url" 
											:title="entry.title"
											site-name="Skoften"
											mailto="info@skoften.net"
											:nav-bar-item="true"
											:show-label="false"
										></article-share> 
							
										<up-vote 
											ref="voting" 
											:element-id="entry.id"
											:up-votes="entry.votes.totalUpVotes"
											:show-up-vote="true"
											:show-down-vote="false"
											:show-tally-vote="false"
											:nav-bar-item="true"
										></up-vote>	
									
										<comments-modal v-if="entry.commenting" 
											:total-comments="entry.totalComments" 
											:url="'/async/comments?id=' + entry.id"
											:js-variables="entry.commentsVariables"
											:nav-bar-item="true"
											:show-label="false"
										></comments-modal>
										
										<a href="javascript:void(0)" class="uk-navbar-item uk-padding-small" role="button" aria-haspopup="true" @click="closeModal">
											<span class="uk-visible@s">Sluiten</span><span class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span>
										</a>
							
									</div>
								</div>
							</div>
							<!-- // footer -->
							
						</div>
							
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

import LoadingIndicator from './LoadingIndicator.vue';
import { defineAsyncComponent } from 'vue';
const VideoPlayer = defineAsyncComponent(() => import('./VideoPlayer.vue'));
import CommentsModal from './CommentsModal.vue'
import UpVote from './UpVote.vue'
import ArticleShare from './ArticleShare.vue'

export default {
	components: {
		LoadingIndicator, 
		VideoPlayer,
		CommentsModal,
		UpVote,
		ArticleShare
	},
	props: {
	},
	data() {
		return {
			showModal: false,
			content: String,
			entry: {
				type: Object,
				default() {
					return {
					};
				}	
			},
			feedUrl: '/feeds/videos.json',
			loading: false,
			touchStartX: 0,
			touchStartY: 0			
		}
	},	
	mounted() {
		document.addEventListener('keydown', this.handleEscapeKey);
	},
	unmounted() {
		document.removeEventListener('keydown', this.handleEscapeKey);
	},	
	methods: {
		closeModalViaBackground(e) {
			var component = this;
			if(e.target == component.$refs.modalBackground) {
				component.closeModal();
			}
		},
		toggleModal() {
			this.showModal = (this.showModal) ? false : true;
			this.toggleBodyClass();
			this.loading = true;
		},
		openModal() {
			this.showModal = true;
			this.toggleBodyClass();
		},
		closeModal() {
			this.showModal = false;
			this.toggleBodyClass();
		},
		toggleBodyClass() {
			document.body.classList.toggle('modalX-active');
		},
		handleEscapeKey(e) {
			if (e.key === 'Escape' && this.showModal) {
				this.closeModal();
			}
		},		
		loadVideo(entryId) {
			
			var component = this;
			var url = component.feedUrl;
			component.loading = true;
			
			// Add entryId
			url = this.$helper.updateQueryStringParameter(url, 'entryId', entryId);
			
			component.$logger('app/component/video-modal/load-video/url:' + url);

			axios
				.get(url)
				.then((response) => {
					component.entry = {...response.data.items[0]};
					component.loading = false;
				})
				.catch((error) => {
					this.error = 'An error occurred while fetching entries.';
					if(typeof error != 'undefined') {
						console.error(error);
					}
					component.loading = false;
				});
			
		}
	}
};
</script>

<style scoped>

html.modalX-active, body.modalX-active {
	overflow: hidden;
}

#modalX-container {
	position: fixed;
	display: table;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	transform: scale(0);
	z-index: 9999;
}

#modalX-container .modalX-background .modalX {
	border-radius: 10px;
}
#modalX-container.one {
	transform: scaleY(0.01) scaleX(0);
	animation: unfoldIn 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.one .modalX-background .modalX {
	transform: scale(0);
	animation: zoomIn 0.5s 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.one.out {
	transform: scale(1);
	animation: unfoldOut 1s 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.one.out .modalX-background .modalX {
	animation: zoomOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.two {
	transform: scale(1);
}
#modalX-container.two .modalX-background {
	background: rgba(0, 0, 0, 0);
	animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.two .modalX-background .modalX {
	opacity: 0;
	animation: scaleUp 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.two + .content {
	animation: scaleBack 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.two.out {
	animation: quickScaleDown 0s 0.5s linear forwards;
}
#modalX-container.two.out .modalX-background {
	animation: fadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.two.out .modalX-background .modalX {
	animation: scaleDown 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.two.out + .content {
	animation: scaleForward 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.three {
	z-index: 9999;
	transform: scale(1);
}
#modalX-container.three .modalX-background {
	background: rgba(0, 0, 0, 0.6);
}
#modalX-container.three .modalX-background .modalX {
	border-radius: 10px;
	animation: moveUp 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.three + .content {
	z-index: 9999;
	animation: slideUpLarge 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.three.out .modalX-background .modalX {
	z-index: 9999;
	animation: moveDown 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.three.out + .content {
	z-index: 9999;
	animation: slideDownLarge 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.four {
	z-index: 9999;
	transform: scale(1);
}
#modalX-container.four .modalX-background {
	background: rgba(0, 0, 0, 0.7);
}
@media only screen and (max-width: 640px) {
	#modalX-container.four .modalX-background {
		background: white;
	}	
}

#modalX-container.four .modalX-background .modalX {
	padding-bottom: 0;
	animation: blowUpmodalX 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.four + .content {
	z-index: 9999;
	animation: blowUpContent 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.four.out .modalX-background .modalX {
	animation: blowUpmodalXTwo 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.four.out + .content {
	animation: blowUpContentTwo 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.five {
	transform: scale(1);
}
#modalX-container.five .modalX-background {
	background: rgba(0, 0, 0, 0);
	animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.five .modalX-background .modalX {
	transform: translateX(-1500px);
	animation: roadRunnerIn 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.five.out {
	animation: quickScaleDown 0s 0.5s linear forwards;
}
#modalX-container.five.out .modalX-background {
	animation: fadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.five.out .modalX-background .modalX {
	animation: roadRunnerOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six {
	transform: scale(1);
}
#modalX-container.six .modalX-background {
	background: rgba(0, 0, 0, 0);
	animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six .modalX-background .modalX {
	background-color: transparent;
	animation: modalXFadeIn 0.5s 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six .modalX-background .modalX h2, #modalX-container.six .modalX-background .modalX p {
	opacity: 0;
	position: relative;
	animation: modalXContentFadeIn 0.5s 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six .modalX-background .modalX .modalX-svg rect {
	animation: sketchIn 0.5s 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six.out {
	animation: quickScaleDown 0s 0.5s linear forwards;
}
#modalX-container.six.out .modalX-background {
	animation: fadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six.out .modalX-background .modalX {
	animation: modalXFadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six.out .modalX-background .modalX h2, #modalX-container.six.out .modalX-background .modalX p {
	animation: modalXContentFadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.six.out .modalX-background .modalX .modalX-svg rect {
	animation: sketchOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.seven {
	transform: scale(1);
}
#modalX-container.seven .modalX-background {
	background: rgba(0, 0, 0, 0);
	animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.seven .modalX-background .modalX {
	height: 75px;
	width: 75px;
	border-radius: 75px;
	overflow: hidden;
	animation: bondJamesBond 1.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.seven .modalX-background .modalX h2, #modalX-container.seven .modalX-background .modalX p {
	opacity: 0;
	position: relative;
	animation: modalXContentFadeIn 0.5s 1.4s linear forwards;
}
#modalX-container.seven.out {
	animation: slowFade 0.5s 1.5s linear forwards;
}
#modalX-container.seven.out .modalX-background {
	background-color: rgba(0, 0, 0, 0.7);
	animation: fadeToRed 2s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.seven.out .modalX-background .modalX {
	border-radius: 10px;
	height: 162px;
	width: 227px;
	animation: killShot 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container.seven.out .modalX-background .modalX h2, #modalX-container.seven.out .modalX-background .modalX p {
	animation: modalXContentFadeOut 0.5s 0.5 cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
#modalX-container .modalX-background {
	display: table-cell;
	background: rgba(0, 0, 0, 0.8);
	text-align: center;
	vertical-align: middle;
}
#modalX-container .modalX-background .modalX {
	background: white;
	padding: 20px;
	display: inline-block;
	border-radius: 10px;
	font-weight: 300;
	position: relative;
}
#modalX-container .modalX-background .modalX h2 {
	font-size: 25px;
	line-height: 25px;
	margin-bottom: 15px;
}
#modalX-container .modalX-background .modalX p {
	font-size: 18px;
	line-height: 22px;
}
#modalX-container .modalX-background .modalX .modalX-svg {
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	border-radius: 10px;
}
#modalX-container .modalX-background .modalX .modalX-svg rect {
	stroke: #fff;
	stroke-width: 2px;
	stroke-dasharray: 778;
	stroke-dashoffset: 778;
}

.content {
	min-height: 100%;
	height: 100%;
	background: white;
	position: relative;
	z-index: 9999;
}
.content h1 {
	padding: 75px 0 30px 0;
	text-align: center;
	font-size: 30px;
	line-height: 30px;
}
.content .buttons {
	max-width: 800px;
	margin: 0 auto;
	padding: 0;
	text-align: center;
}
.content .buttons .button {
	display: inline-block;
	text-align: center;
	padding: 10px 15px;
	margin: 10px;
	background: red;
	font-size: 18px;
	background-color: #efefef;
	border-radius: 10px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
	cursor: pointer;
}
.content .buttons .button:hover {
	color: white;
	background: #009bd5;
}

@keyframes unfoldIn {
	0% {
		transform: scaleY(0.005) scaleX(0);
	}
	50% {
		transform: scaleY(0.005) scaleX(1);
	}
	100% {
		transform: scaleY(1) scaleX(1);
	}
}
@keyframes unfoldOut {
	0% {
		transform: scaleY(1) scaleX(1);
	}
	50% {
		transform: scaleY(0.005) scaleX(1);
	}
	100% {
		transform: scaleY(0.005) scaleX(0);
	}
}
@keyframes zoomIn {
	0% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
}
@keyframes zoomOut {
	0% {
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
}
@keyframes fadeIn {
	0% {
		background: rgba(0, 0, 0, 0);
	}
	100% {
		background: rgba(0, 0, 0, 0.7);
	}
}
@keyframes fadeOut {
	0% {
		background: rgba(0, 0, 0, 0.7);
	}
	100% {
		background: rgba(0, 0, 0, 0);
	}
}
@keyframes scaleUp {
	0% {
		transform: scale(0.8) translateY(1000px);
		opacity: 0;
	}
	100% {
		transform: scale(1) translateY(0px);
		opacity: 1;
	}
}
@keyframes scaleDown {
	0% {
		transform: scale(1) translateY(0px);
		opacity: 1;
	}
	100% {
		transform: scale(0.8) translateY(1000px);
		opacity: 0;
	}
}
@keyframes scaleBack {
	0% {
		transform: scale(1);
	}
	100% {
		transform: scale(0.85);
	}
}
@keyframes scaleForward {
	0% {
		transform: scale(0.85);
	}
	100% {
		transform: scale(1);
	}
}
@keyframes quickScaleDown {
	0% {
		transform: scale(1);
	}
	99.9% {
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
}
@keyframes slideUpLarge {
	0% {
		transform: translateY(0%);
	}
	100% {
		transform: translateY(-100%);
	}
}
@keyframes slideDownLarge {
	0% {
		transform: translateY(-100%);
	}
	100% {
		transform: translateY(0%);
	}
}
@keyframes moveUp {
	0% {
		transform: translateY(150px);
	}
	100% {
		transform: translateY(0);
	}
}
@keyframes moveDown {
	0% {
		transform: translateY(0px);
	}
	100% {
		transform: translateY(150px);
	}
}
@keyframes blowUpContent {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	99.9% {
		transform: scale(2);
		opacity: 0;
	}
	100% {
		transform: scale(0);
	}
}
@keyframes blowUpContentTwo {
	0% {
		transform: scale(2);
		opacity: 0;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}
@keyframes blowUpmodalX {
	0% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
}
@keyframes blowUpmodalXTwo {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	100% {
		transform: scale(0);
		opacity: 0;
	}
}
@keyframes roadRunnerIn {
	0% {
		transform: translateX(-1500px) skewX(30deg) scaleX(1.3);
	}
	70% {
		transform: translateX(30px) skewX(0deg) scaleX(0.9);
	}
	100% {
		transform: translateX(0px) skewX(0deg) scaleX(1);
	}
}
@keyframes roadRunnerOut {
	0% {
		transform: translateX(0px) skewX(0deg) scaleX(1);
	}
	30% {
		transform: translateX(-30px) skewX(-5deg) scaleX(0.9);
	}
	100% {
		transform: translateX(1500px) skewX(30deg) scaleX(1.3);
	}
}
@keyframes sketchIn {
	0% {
		stroke-dashoffset: 778;
	}
	100% {
		stroke-dashoffset: 0;
	}
}
@keyframes sketchOut {
	0% {
		stroke-dashoffset: 0;
	}
	100% {
		stroke-dashoffset: 778;
	}
}
@keyframes modalXFadeIn {
	0% {
		background-color: transparent;
	}
	100% {
		background-color: white;
	}
}
@keyframes modalXFadeOut {
	0% {
		background-color: white;
	}
	100% {
		background-color: transparent;
	}
}
@keyframes modalXContentFadeIn {
	0% {
		opacity: 0;
		top: -20px;
	}
	100% {
		opacity: 1;
		top: 0;
	}
}
@keyframes modalXContentFadeOut {
	0% {
		opacity: 1;
		top: 0px;
	}
	100% {
		opacity: 0;
		top: -20px;
	}
}
@keyframes bondJamesBond {
	0% {
		transform: translateX(1000px);
	}
	80% {
		transform: translateX(0px);
		border-radius: 75px;
		height: 75px;
		width: 75px;
	}
	90% {
		border-radius: 10px;
		height: 182px;
		width: 247px;
	}
	100% {
		border-radius: 10px;
		height: 162px;
		width: 227px;
	}
}
@keyframes killShot {
	0% {
		transform: translateY(0) rotate(0deg);
		opacity: 1;
	}
	100% {
		transform: translateY(300px) rotate(45deg);
		opacity: 0;
	}
}
@keyframes fadeToRed {
	0% {
		background-color: rgba(0, 0, 0, 0.6);
	}
	100% {
		background-color: rgba(255, 0, 0, 0.8);
	}
}
@keyframes slowFade {
	0% {
		opacity: 1;
	}
	99.9% {
		opacity: 0;
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
}

/* DARK MODE */

body.dark #modalX-container .modalX-background .modalX {
	background-color: var(--card-background-color-dark);
}
</style>
